<!--学生端教材版本-->
<template>
  <div class="uni-book-version">
    <div class="textbookVersions">
      <div class="textbookVersions-table">
        <el-table
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          :data="tableData"
          border
        >
          <el-table-column prop="code" label="课程代码"> </el-table-column>
          <el-table-column prop="course_title" label="课程名称"> </el-table-column>
          <el-table-column prop="title" label="教材名称"> </el-table-column>
          <el-table-column prop="edition" label="教材版本"> </el-table-column>
          <el-table-column prop="author" label="作者"> </el-table-column>
          <el-table-column prop="press" label="出版社"> </el-table-column>
          <el-table-column prop="start_date" label="启用时间"> </el-table-column>
<!--          <el-table-column  label="教材名称">-->
<!--            <template v-slot="scoped">{{scoped.row.title}}</template>-->
<!--          </el-table-column>-->
<!--          <el-table-column  label="教材版本">-->
<!--            <template v-slot="scoped">{{scoped.row.edition}}</template>-->
<!--            </el-table-column>-->
<!--          <el-table-column  label="作者">-->
<!--            <template v-slot="scoped">{{scoped.row.author}}</template>-->
<!--          </el-table-column>-->
<!--          <el-table-column  label="出版社">-->
<!--            <template v-slot="scoped">{{scoped.row.press}}</template>-->
<!--          </el-table-column>-->
<!--          <el-table-column  label="启用时间">-->
<!--            <template v-slot="scoped">{{scoped.row.start_date}}</template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getMaterial } from "@/api/basic";
//import Template from "../../layout/template";

export default {
  name: "index",
  //components: {Template},
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.getMaterial();
  },
  methods: {
    async getMaterial() {
      const { result } = await getMaterial();
      console.log(result)
      if (result) {
        this.tableData = result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-book-version {
  min-height: $contentH;
  padding-bottom: 0;
}
.textbookVersions {
  min-height: inherit;
  border-radius: 5px;
  background-color: #ffffff;
  overflow: hidden;

  h2 {
    margin: 30px 0;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
  }
  .textbookVersions-table {
    margin-bottom: 40px;
    /deep/ .el-table th {
      text-align: center;
    }
    /deep/ .el-table td {
      text-align: center;
    }
  }
}
</style>
